import ProductsListController from './productsListController';
import ListService from './../services/listService';
import './productsList.scss';
import UserService from '../../user/services/userService';
import DateFormatFilter from '../../../filters/dateFormat';

const ProductsListComponent = {
    template: require('./productsListView.html'),
    controller: ProductsListController
};

export default angular.module('app.productslist', [require('angular-material-data-table')])
    .component('productslist', ProductsListComponent)
    .filter('dateFormat', DateFormatFilter)
    .service('ListService', ListService)
    .service('UserService', UserService)
    .name;



// WEBPACK FOOTER //
// ./src/app/pages/lists/productsList/productsListComponent.js